import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';

export default function AddAGrappleSmallPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-[#dc3545] hover:underline">HOME</Link>
            <span>/</span>
            <span className="text-gray-600">SMALL</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Images and Video */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <img
                              src="/images/AAGSM.jpg"
                alt="Add A Grapple Small"
                className="w-full h-auto"
              />
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
             
            </div>
          </div>

          {/* Right Column - Product Info */}
          <div className="bg-white rounded-lg p-8 shadow-md">
            
            <h1 className="text-3xl font-bold text-[#333333] mb-4">SMALL</h1>
            <h4 className="text-lg text-[#666666] mb-2">Model: 114400</h4>
            <h4 className="text-lg text-[#666666] mb-6">Weight: 132 lbs</h4>

            <h2 className="text-2xl font-bold text-[#333333] mb-4">
              Easily Convert Your Bucket Into a Versatile Grapple Bucket, 35″ Opening!
            </h2>

            <div className="space-y-4 text-[#666666] mb-6">
              <p>
                The Add A Grapple Small is the perfect fit for buckets in between our AAG Mini & Single/Double models. The AAG Small is designed to convert buckets that are between 45″ and 63″ in width into a grapple bucket. Just like our original Add A Grapples, it's ideal for compact and utility tractors up to 50 hp and offers an easy and affordable way to enhance your tractor's versatility. The grapple is easily removed while the mount stays in place. See our Grapple Spec Sheet and Add A Grapple Selector below to choose the correct Add A Grapple for your bucket.
              </p>
              <p>
                Each Add A Grapple Small is designed for durability and performance, featuring curved teeth that provide a wider grip and allow for easy release of materials. Check out our Grapple Spec Sheet and Add A Grapple Selector below to find the right model for your bucket.
              </p>
              <p>
                All pivot points are greased to ensure smooth operation and long-lasting wear, making this bucket grapple a reliable attachment for various tasks. It's the perfect solution for those looking to add a grapple without the need for a completely new bucket.
              </p>
            </div>

            <hr className="my-6" />

            {/* Features Accordion */}
            <div className="mb-6">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none font-bold text-lg text-[#333333] py-3 border-b">
                  FEATURES
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <ul className="mt-4 space-y-2 text-[#666666] list-disc list-inside">
                  <li>35″ Grapple Opening, Fits Buckets 45″ to 63″ in Width</li>
                  <li>Converts Existing Bucket into a Grapple Bucket</li>
                  <li>Curved Teeth for Wider Grip and Easy Release of Material</li>
                  <li>Grapple Can Be Removed to Convert Back to Bucket Only</li>
                </ul>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4">
              <a
                href="/contact"
                className="block w-full bg-[#dc3545] hover:bg-[#c82333] text-white text-center py-3 px-6 font-bold rounded transition-colors"
              >
                Call Us Now
              </a>
              
              
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-md">
          <h3 className="text-2xl font-bold text-[#333333] mb-6">FREQUENTLY ASKED QUESTIONS</h3>
          <div className="space-y-6 text-[#666666]">
            <div>
              <p className="font-bold text-[#333333] mb-2">
                Q: How does the Add A Grapple Small convert a regular bucket into a grapple bucket for a tractor?
              </p>
              <p>
                <strong>A:</strong> The Add A Grapple Small is designed to easily attach to existing tractor buckets that are 45″ to 63″ wide, converting them into fully functional grapple buckets. This attachment provides a secure grip with its curved teeth, allowing you to handle various materials like brush, debris, and more. It's an efficient way to enhance your tractor's versatility without needing to purchase a new bucket.
              </p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">
                Q: Is the Add A Grapple Small compatible with compact and utility tractors?
              </p>
              <p>
                <strong>A:</strong> Yes, the Add A Grapple Small is specifically designed for compact and utility tractors with up to 50 horsepower. This bucket grapple attachment easily fits onto standard buckets, making it ideal for smaller tractors that need the functionality of a grapple bucket without the added weight or complexity of a larger setup.
              </p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">
                Q: Can I easily remove the Add A Grapple Small when I don't need it?
              </p>
              <p>
                <strong>A:</strong> Absolutely! The Add A Grapple Small is designed for flexibility. The grapple can be quickly removed, allowing you to revert back to using your bucket as a standard tractor bucket. The mounting system stays in place, making it easy to switch between a regular bucket and a grapple bucket whenever needed.
              </p>
            </div>
          </div>
        </div>

      

        {/* Disclaimer */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-md text-center">
          <h3 className="text-xl font-bold text-[#dc3545] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

     
    </div>
  );
}
